import { owcTheme } from 'core/theme/theme.config';
import { PocComponentHeader, PocHeaderRow, PocTypography } from 'commons/components/components-wrapper';
import styled from 'styled-components';

export const SubmoduleHeaderStyledComponent = styled(PocComponentHeader)`
    display: flex;
    width: 100%;
    height: auto;
    padding: 16px 24px 0;

    > div {
        width: 100%;

        /* The top gap keeps the border visible without removing horizontal clipping. */
        padding-top: 4px;
        overflow: hidden;
    }

    > div > div {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    owc-header-row {
        height: 100%;
        padding: 0;
    }

    owc-header-row:first-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: auto;
        padding-right: 2px;
        margin-bottom: 16px;

        > div {
            display: flex;
            align-items: start;
        }
    }

    owc-header-row:last-child {
        > owc-tabs {
            overflow-y: auto;
        }
    }
`;

export const SubmoduleHeaderTitleRow = styled(PocHeaderRow)`
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    gap: 10rem;
    min-width: 0;
`;

export const SubmoduleHeaderTabsRow = styled(PocHeaderRow).withConfig({
    shouldForwardProp: (prop) => prop !== 'inset',
})<{ inset: boolean }>`
    padding-left: ${({ inset }) => (inset ? owcTheme['one-spacer-px-24'] : '0')};
`;

export const SubmoduleHeaderTitleContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'hasPrefixIcon',
})<{ hasPrefixIcon: boolean }>`
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    min-width: 0;
    padding-left: ${({ hasPrefixIcon }) => (hasPrefixIcon ? '0' : owcTheme['one-spacer-px-16'])};
`;

export const SubmoduleHeaderTitleInfoContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    min-width: 0;
    text-wrap: pretty;
`;

export const SubmoduleHeaderSubTitle = styled(PocTypography)`
    color: ${owcTheme['one-color-interaction-default-contrast-higher']};
`;

export const SubmoduleHeaderSuffixContainer = styled.div`
    display: flex;
    gap: ${owcTheme['one-spacer-px-8']};
    align-items: center;
`;
